import { buildFormSelector } from 'core/utils';

/**
 * @param BackInStock Base widget for extending
 * @returns CoreBackInStock widget
 */
function CoreBackInStockClassCreator(BackInStock: import('widgets/forms/ajax/BackInStock').TBackInStock) {
    class CoreBackInStock extends BackInStock {
        prefs() {
            return {
                productId: '',
                analytics: null as { [key: string]: unknown } | null,
                ...super.prefs()
            };
        }

        init() {
            super.init();

            this.initFriendlyCaptcha();
        }

        initFriendlyCaptcha() {
            const form = this.ref('self').get() as HTMLFormElement;
            const selector = buildFormSelector(form, false);

            if (selector) {
                this.eventBus().emit('captcha.init', selector);
            }
        }

        /**
         * @description Updates product ID in preferences and set the value to input field
         * @param productId Product ID to be set
         */
        updateProductId(productId: string): void {
            this.setPref('productId', productId);

            super.updateProductId(productId);
        }

        /**
         * @description Handles form submission
         */
        handleSubmit(): Promise<null | Record<string, unknown>> {
            if (!this.prefs().productId) {
                this.isChildrenValid();
                this.emit('emptyproductid');

                return Promise.resolve(null);
            }

            return super.handleSubmit().then(response => {
                if (response?.success) {
                    const analytics = this.prefs().analytics;

                    if (analytics && typeof analytics.event_name === 'string') {
                        analytics[analytics.event_name] = {
                            ...(analytics[analytics.event_name] || {}),
                            item_variant: this.prefs().productId
                        };
                        this.eventBus().emit('gtm.event', analytics);
                    }
                }

                return response;
            });
        }
    }

    return CoreBackInStock;
}

export type TCoreBackInStock = ReturnType<typeof CoreBackInStockClassCreator>;

export type TCoreBackInStockInstance = InstanceType<TCoreBackInStock>;

export default CoreBackInStockClassCreator;
